import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Grid,
  Input,
  Typography,
} from "@mui/material";
import { ErrorMessage, FieldArray, FormikValues, useFormikContext } from "formik";
import FormDropdownField from "../../../common/Form/Dropdown/FormDropdownField";
import styles from "../Meeting.module.scss";
import UploadFile from "../../../common/UploadFile/UploadFile";
import { AddCircleOutline, Close } from "@mui/icons-material";
import { project as _project } from "../utils";
import { useRef } from "react";
import Documents from "./Documents";
import { useGetProtocolListQuery } from "../../../../generated/graphql";
import { SUBMISSION_TYPES } from "../../../../constants";

const Projects = (): JSX.Element => {
  const { values, touched, errors, setFieldValue, setValues } = useFormikContext<FormikValues>();
  const ArrayHelperRef: any = useRef();
  const { data, loading, error } = useGetProtocolListQuery({
    variables: {
      subType: "",
      submissionType: SUBMISSION_TYPES.MEETING,
    },
  });
  const protocolNumbers = data?.getProtocolList.map((item, i) => {
    return { label: item.protocolNumber, value: item._id };
  });
  const dropdownInputHandlerPN = async (
    name: string,
    newValue: any,
    i: number
  ) => {
    const projects = [...values.projects];
    projects[i]._id = newValue;
    setFieldValue("projects", projects);
  };
  return (
    <>
      <Box className="mg-t-50">
        <label className="form-label mg-b-20 font-size-14">5. Project</label>

        <FieldArray
          name="projects"
          render={(arrayHelpers) => {
            ArrayHelperRef.current = arrayHelpers;
            return (
              <Box>
                {values.projects.map((p: any, index: any) => (
                  <Card key={index} className={`mg-b-20`}>
                    <CardHeader
                      action={
                        index > 0 && (
                          <Button
                            onClick={() => arrayHelpers.remove(index)}
                            variant={"text"}
                            color={"error"}
                            size={"small"}
                            className={`font-weight-medium pd-x-0`}
                            sx={{ minWidth: "unset" }}
                          >
                            <Close className={`font-size-lg`} />
                          </Button>
                        )
                      }
                      // title="Shrimp and Chorizo Paella"
                      // subheader="September 14, 2016"
                    />
                    <CardContent>
                      <Box>
                        <FormDropdownField
                          label="Protocol Number/Short Title/Study Title"
                          value={p._id}
                          name={"_id"}
                          options={protocolNumbers}
                          inputHandler={(name, newValue) =>
                            dropdownInputHandlerPN(name, newValue, index)
                          }
                          className={`mg-b-10`}
                          // disabled={!!id}
                        />

                        <Documents index={index} fieldName="projects" />
                        
                        {(touched as any)?.['projects']?.[index]?._id && (errors as any)?.['projects']?.[index]?._id && <span className="text-danger font-size-sm">{(errors as any)?.['projects']?.[index]?._id.label }</span>}
                      </Box>
                    </CardContent>
                  </Card>
                ))}
              </Box>
            );
          }}
        />
      </Box>
      <Box className="d-flex justify-content-spacebetween">
        <Button
          variant={"outlined"}
          onClick={() =>
            ArrayHelperRef.current.push({
              ..._project,
              documents: [
                // ..._project.documents,//does not work
                {
                  label: "Approval Letters",
                  required: false,
                  url: "",
                  isEditable: false,
                  isInputOpened: false,
                },
                {
                  label: "Recommendation letter",
                  required: false,
                  url: "",
                  isEditable: false,
                  isInputOpened: false,
                },
              ],
            })
          }
          color={"error"}
        >
          <AddCircleOutline className={`mg-r-10 font-size-lg`} />{" "}
          <span className={`font-size-sm`}>Add More</span>
        </Button>
      </Box>
    </>
  );
};

export default Projects;
